import { formatDate } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CommonModalFormComponent } from '@shared/components/commons/common-modal-form/common-modal-form.component';
import { DisclaimerComponent } from "@shared/components/commons/disclaimer/disclaimer.component";
import { DatePickerComponent } from '@shared/controls/date-picker/date-picker.component';
import { DatepickerHelper } from '@shared/validators/date-picker-form-validators';

@Component({
  selector: 'app-mark-as-signed',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModalFormComponent,
    DatePickerComponent,
    DisclaimerComponent
  ],
  templateUrl: 'mark-as-signed.component.html',
  styleUrl: 'mark-as-signed.component.scss'
})
export class MarkAsSignedComponent implements OnInit {
  activeModal = inject(NgbActiveModal);

  @Input() earliestChangeDate!: Date;
  @Input() isDocument!: boolean;
  @Input() inSignedProcess!: boolean;

  @Output() confirm = new EventEmitter<{ signingDate: string; lodge: boolean }>();

  documentMessage = 'Changing the Signing Status to Signed will not lodge the form with ASIC. Do you want also to lodge the form?';
  asMessage = 'To proceed add the date of signing.';

  signedWarning = 'Please note that if eSigning is currently in progress, marking the document as “Signed” will void the envelope and prevent the signatories from completing the signing process.';
  signingDate = new Date();
  formattedSigningDate = '';
  signingDateControl = new FormControl<Date | null>(new Date(), Validators.required);
  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;

  ngOnInit(): void {
    this.minDate = DatepickerHelper.getStructFromDateOrNull(this.earliestChangeDate)!;
    this.maxDate = DatepickerHelper.getTodayStruct();
  }

  get message(): string {
    if (this.isDocument) {
      return this.documentMessage;
    }

    return this.asMessage;
  }

  lodge() {
    if (this.signingDateControl.invalid) {
      this.signingDateControl.markAsTouched();
      return;
    }

    const result = {
      signingDate: this.getFormattedDate(),
      lodge: true,
    };

    this.confirm.emit(result);
    this.activeModal.close();
  }

  markAsSigned() {
    if (this.signingDateControl.invalid) {
      this.signingDateControl.markAsTouched();
      return;
    }

    const result = {
      signingDate: this.getFormattedDate(),
      lodge: false,
    };

    this.confirm.emit(result);
    this.activeModal.close();
  }

  onClose(): void {
    this.activeModal.close();
  }

  getFormattedDate(): string {
    if (this.signingDateControl.invalid || !this.signingDateControl.value) {
      return '';
    }

    return formatDate(this.signingDateControl.value, 'yyyy-MM-dd', 'en-US');
  }
}
